export enum ERROR_CODE {
  NewUser = 'NEW_USER',
  ExistingUser = 'EXISTING_USER',
}
